@if (config.library==='plotly' && chart) {
  <plotly-plot
    [data]="chart.data"
    [layout]="chart.layout"
    [config]="chart.config"
    [useResizeHandler]="true"
    [style]="{position: 'relative', width: '100%', height: '100%'}"
    (legendClick)="handleLegendClick($event)">
  </plotly-plot>
}
